import { defineComponent as _defineComponent } from 'vue'
import { Events, Userspaces } from "@busy-human/k9-library";
import { computed, onMounted, ref } from "vue";
import { useUserspace } from "@/store/useUsers";
import type { DataInstance } from "@busy-human/gearbox";

type AugmentedEvent = {
	event: Events.Model
	startColumn: number
	endColumn: number
	startsBefore: boolean
	endsAfter: boolean
	backgroundColor?: string
	foregroundColor?: string
};

type Props = {
	eventDetail: null | AugmentedEvent,
	dogInfo: any | null,
};

type Emits = {
	(e: 'close:selectedEvent'): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'event-tooltip',
  props: {
    eventDetail: { default: null },
    dogInfo: { default: null }
  },
  emits: ["close:selectedEvent"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();


const emit = __emit;

const props = __props;

const closeDetail = () => {
	console.log("props.eventDetail = null");
	emit('close:selectedEvent');
};


const userStore = useUserspace();
const ownerRef = userStore.asArray;

const ownerName = ref("");

const getOwnerName = () => {
	if(props.dogInfo.owner) {
		const ownerID = props.dogInfo.owner;
		const ownerInfo = ownerRef.filter(owner => owner.$id === ownerID);
		console.log("LOOK:", ownerInfo);

		ownerName.value = ownerInfo.map((item)=>item.name.fullName).toString();
	}
};



const calColor  = ref<string>("#2288ff");
const startDate = ref("");
const startTime = ref("");
const   endDate = ref("");
const   endTime = ref("");

const getDisplayDate = () => {
	const currentOffset = new Date().getTimezoneOffset();
	if (props.eventDetail?.event?.startTime){
		const startOffsetted = new Date(props.eventDetail.event.startTime);
		const endOffsetted = new Date(props.eventDetail.event.endTime);

		startOffsetted.setMinutes(currentOffset);
		endOffsetted.setMinutes(currentOffset);

		startDate.value = new Date(startOffsetted).toLocaleDateString([], {month: "short", day: "numeric", year: "numeric" });
		endDate.value =   new Date(endOffsetted  ).toLocaleDateString([], {month: "short", day: "numeric", year: "numeric" });
		if('eventType' in props.eventDetail.event && props.eventDetail.event.eventType === 'pickup-dropoff'){
			startTime.value = new Date(props.eventDetail?.event.startTime).toLocaleTimeString([], {hour: "numeric", minute: "numeric"});
			endTime.value =   new Date(props.eventDetail?.event.endTime  ).toLocaleTimeString([], {hour: "numeric", minute: "numeric"});
		}
	}
};


onMounted(()=>{
	getDisplayDate();
	calColor.value = props.eventDetail?.backgroundColor || "#88ff88";
	console.info(" PROPSP : ", props.eventDetail,
		"\n \n \n ---  props . dog info: ",props.dogInfo,
		"\n \n \n ---  start date: ", startDate,
		"\n \n \n ---  end date: ", endDate,
	);
	getOwnerName();
});


const __returned__ = { emit, props, closeDetail, userStore, ownerRef, ownerName, getOwnerName, calColor, startDate, startTime, endDate, endTime, getDisplayDate, get Events() { return Events }, get Userspaces() { return Userspaces }, computed, onMounted, ref, get useUserspace() { return useUserspace } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})